import _                                  from 'underscore';
import React, { FC, useEffect, useState } from 'react';
import { useQuery }                       from '@apollo/react-hooks';

import { CorvalStaticProjectActivity, Uuid }    from '@src/types';
import { queriesHaveData, queriesLoading }      from '@src/store/_apolloUtil';
import { formatOption, IFormatOptionValue }     from '@src/util';
import { QueriedSelectFieldProps, SelectField } from '@src/views/components/forms';
import { ActivityQueries }                      from "@src/queries/ActivityQueries";


interface ProjectVersionCategoriesDropdownProps extends QueriedSelectFieldProps {
    projectId: Uuid,
    projectVersionId: Uuid,
    categoriesOnly?: boolean,
    loading?: boolean,
    formatOptions?: object,
}

const defaultProps: ProjectVersionCategoriesDropdownProps = {
    projectId:        null,
    projectVersionId: null,
    categoriesOnly:   true,
    loading:          false,
    formatOptions:    {}
};

const ProjectVersionCategoriesDropdown: FC<ProjectVersionCategoriesDropdownProps> = ( _props ) => {

    let { formatOptions, projectVersionId, projectId, categoriesOnly, ...props } = _props;

    const [ categories, setCategories ] = useState<IFormatOptionValue[]>( [] );

    const getStaticProjectActivitiesReq = useQuery<{ staticProjectActivities: CorvalStaticProjectActivity[] }>(
        ActivityQueries.queries.GET_PROJECT_ACTIVITIES( `
            id 
            categoryId 
            categoryName 
            categoryOrdinal 
            subCategoryId 
            subCategoryName
            subCategoryOrdinal
        ` ), {
            variables:   { projectVersionId },
            skip:        ( !projectId || !projectVersionId ),
            fetchPolicy: 'cache-and-network'
        } );

    const isLoading = ( props.loading || queriesLoading( [ getStaticProjectActivitiesReq ] ) );

    useEffect( () => {

        if( queriesHaveData( [ getStaticProjectActivitiesReq ] ) ){

            const categoryOptions = _.chain( getStaticProjectActivitiesReq.data.staticProjectActivities )
                                     .uniq( item => ( item.categoryId ) )
                                     .sortBy( item => ( item.categoryName ) )
                                     .map( item => formatOption( item.categoryId, item.categoryName ) )
                                     .value();

            const subCategoryOptions = _.chain( getStaticProjectActivitiesReq.data.staticProjectActivities )
                                        .uniq( item => ( item.subCategoryId ) )
                                        .sortBy( item => ( item.subCategoryOrdinal ) )
                                        .map( item => formatOption( item.subCategoryId, item.subCategoryName, { group: item.categoryName } ) )
                                        .value();

            if( categoriesOnly ){
                setCategories( categoryOptions );
            } else {
                setCategories( _.sortBy( subCategoryOptions, item => ( item.group ) ) );
            }
        }

    }, [ getStaticProjectActivitiesReq ] );

    return (
        <SelectField
            { ...props }
            search
            loading={ isLoading }
            options={ categories }
            useGroupNames={ !categoriesOnly }
        />
    );
};

ProjectVersionCategoriesDropdown.defaultProps = defaultProps;

export { ProjectVersionCategoriesDropdown };
